import React, { useState } from "react";

const FaqItem = ({ question, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border-b border-neutral-200 last:border-b-0">
      <button
        className="w-full flex items-center justify-between py-4 text-left hover:bg-neutral-50 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="font-medium text-neutral-800 pr-4">{question}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-5 w-5 text-neutral-500 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <div className="pb-4 text-neutral-600 leading-relaxed">
          {children}
        </div>
      )}
    </div>
  );
};

const FaqHero = () => (
  <div className="max-w-2xl mx-auto px-4 py-8">
    <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
      <div className="px-6 py-4 border-b border-neutral-200">
        <h2 className="text-lg font-semibold text-neutral-800">Frequently Asked Questions</h2>
        <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
      </div>
      <div className="p-6">
        <FaqItem question="How does this service work?" defaultOpen={true}>
          <p className="mb-3">
            As a signing agent or field inspector, you can register using the <a href="/sign-up" className="text-blue-600 hover:underline font-medium">Sign Up</a> link. Once you register, our team will have a chance to review your information and approve your registration.
          </p>
          <p className="mb-3">
            As soon as you are approved, you'll be eligible to start receiving notifications of assignments in your area and you'll have an opportunity to bid on the assignments. These notifications are sent via SMS, so please be sure to Opt In to receive SMS messages.
          </p>
          <p>
            You will receive a follow up message for all assignments in which you submit an offer, confirming whether your offer is accepted or declined.
          </p>
        </FaqItem>

        <FaqItem question="If I am assigned for a closing, how will I be paid?">
          <p>
            We've spent over twenty years in the signing agent business and are very familiar with the hassles of receiving payment for our work. Our top priority at Pinpoint Field Services is to ensure we are a trusted partner, and prompt payment for services delivered is an important part of being a trusted partner. As soon as you receive an assignment, our team will contact you and work through any additional details, including the payment process.
          </p>
        </FaqItem>

        <FaqItem question="How do I login?">
          <p>
            Your account is tied to your email address. If you are unsure of your password or forgot your password, please select the login link and utilize the <span className="font-medium">Forgot Password</span> link.
          </p>
        </FaqItem>

        <FaqItem question="I've recently become certified in a new state, how do I receive assignments for this new area?">
          <p>
            Once you are logged in, you can access your profile by selecting the link with your name in the upper right corner. Here you can update your profile, including the ability to select up to five states in which you are certified.
          </p>
        </FaqItem>

        <FaqItem question="What if I have a question that isn't answered here?">
          <p>
            Please use the form below to submit any question you may have. Additionally, if you've encountered an issue with our service or have suggestions for improvements, please let us know as well. We really do appreciate your feedback!
          </p>
        </FaqItem>
      </div>
    </div>
  </div>
);

export default FaqHero;